<template>
  <v-btn color="secondary" @click="$router.go(-1)">
    <v-icon left>mdi-keyboard-return</v-icon>
    Regresar
  </v-btn>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "ReturnButton"
});
</script>